import Fetch from '@helpers/Fetch';
import { useQuery, UseQueryResult } from 'react-query';

interface FetchLatestPomelloVersionResponse {
  version: string;
}

export default function useFetchLatestPomelloVersion(): UseQueryResult<string> {
  return useQuery(
    'latestPomelloVersion',
    () =>
      Fetch.get<FetchLatestPomelloVersionResponse>('/api/public/latest-pomello-version/').then(
        response => response.version
      ),
    {
      cacheTime: 1000 * 60 * 60, // 1 hour
      suspense: false,
    }
  );
}
